import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarLeftArrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sidebar-left-arrow"} maskId="square-filled-radius-0-stroke-1-IconSidebarLeftArrow"><path d="M3 3H7V21H3V3Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M21 21H8V3H21V21ZM16.2071 9.5L15.5 8.79289L12.2929 12L15.5 15.2071L16.2071 14.5L13.7071 12L16.2071 9.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSidebarLeftArrow;
